import {CompetitorArticleData} from "../types/competitor-article-data.types";

export const defaultCompetitorArticleData: CompetitorArticleData = {
  id: 0,
  competitorBrandId: 0,
  url: '',
  productTitle: '',
  rating: 0,
  reviewsCount: 0,
  article: 0,
  articleName: '',
  productGroupId: 0,
  marketplaceType: null
}
